export default __webpack_public_path__ + "static/media/Logo.9ee85641.png";